import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-icc',
  templateUrl: './icc.component.html',
  styleUrls: ['./icc.component.scss']
})
export class IccComponent implements OnInit {
  constructor() { }
  ngOnInit(): void { }
}
